'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionTabFilterModel', function (ModelFactory,
                                                  $rootScope,
                                                  TransactionFilterService,
                                                  TransactionSearchModel,
                                                  SearchModel,
                                                  TransactionsModel) {

    var filterModel = ModelFactory.create('TransactionTabFilterModel', [
      'activeTab',
      'transactions'
    ]);
    filterModel.activeTab('all');

    filterModel.isTabActive = function (candidateTab) {
      return filterModel.activeTab() === candidateTab;
    };

    filterModel.onActiveTabChanged($rootScope, updateTransactions);
    SearchModel.onResultsChanged($rootScope, updateTransactions);
    TransactionsModel.onTransactionsChanged($rootScope, updateTransactions);

    filterModel.lastRole = undefined;
    TransactionSearchModel.onParamsChanged($rootScope, function (newParams) {
      var newRole = _.get(newParams, 'role', filterModel.lastRole);
      if (newRole !== filterModel.lastRole) {
        filterModel.activeTab('all');
      }
    });

    function updateTransactions() {
      var filterTransactions = TransactionFilterService.filterTransactions(
        _.camelCase(filterModel.activeTab()),
        TransactionsModel.transactions());

      filterModel.transactions(filterTransactions);
    }

    return filterModel;
  });





//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TransactionTabFilterModel.js
// module id = 594
// module chunks = 0